import api from '@/api';
import PspSearchRequest from '@/model/psp/PspSearchRequest';
import PspRequest from '@/model/psp/PspRequest';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAllPsps(actions, {
      filter,
      pagination,
      sort
    }) {
      return api.base()
        .post('/psp/get/all',
          PspSearchRequest({
            ...(filter || {}),
            pagination,
            sort,
          })
        )
        .then(response => (
          {
            data: response.data.data,
            pagination: {
              page: response.data.metadata.page,
              total: response.data.metadata.total
            },
            sort: response.data.metadata.sort
          })
        );
    },
    getPspList() {
      return api.base()
        .get('/psp/list')
        .then(
          response => {
            return response.data.data;
          }
        );
    },
    getPspById(actions, id) {
      return api.base()
        .get('/psp/id/' + id)
        .then(
          response => {
            return response.data.data;
          }
        );
    },
    createPsp(actions, { psp }) {
      return api.base()
        .post('/psp/add', PspRequest(psp))
        .then(
          response => {
            return response.data.data;
          }
        );
    },
    updatePsp(actions, {
      id,
      psp
    }) {
      return api.base()
        .post('/psp/update/' + id, PspRequest(psp))
        .then(
          response => {
            return response.data.data;
          }
        );
    },
    deletePsp(actions, id) {
      return api.base()
        .delete('/psp/delete/' + id)
        .then(
          response => {
            return response.data.data;
          }
        );
    },
  }

};
